import { graphql } from '@generated/gql';

export const FETCH_LOGO = graphql(/** GraphQL */ `
  query organizationLogoFetchFileDocuments($filter: FileDocumentQueryFilter) {
    fetchFileDocuments(
      input: {
        filter: $filter
        pagination: { perPage: 1, sortDesc: false, sortField: "createdAt" }
      }
    ) {
      fileDocuments {
        id
        name
      }
    }
  }
`);
